import { render, staticRenderFns } from "./DeliveredInTable.vue?vue&type=template&id=34f15406"
import script from "./DeliveredInTable.vue?vue&type=script&lang=js"
export * from "./DeliveredInTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports